export default __webpack_public_path__ + "static/media/10.06a258dc.jpg";